'use strict';

const jQuery = require('jquery');

const Mediator = require('./../../../core/mediator');
const pageRepository = require('./../repository/page');

const markDraft = function() {
    jQuery('#cloud-ui .btn.btn-publish').addClass('is-drafted');
};

module.exports.markDraft = markDraft;

module.exports.init = function() {
  if (jQuery('#cloud-ui').data('page-uid')) {
    setTimeout(() => {
      Mediator.subscribe('content:save', markDraft);
      pageRepository.get({'id': jQuery('#cloud-ui').data('page-uid')}).done(function(page) {
        if (page.is_drafted) {
          markDraft();
        }
      });
    }, 100);
  }
};
